import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum CrmSecurityRight {
    CanAccess = 300000,
    ManageServiceProviders = 300001,
    ManageCustomers = 300002,
    ManageSuppliers = 300003,
    ManageEmployees = 300004,
    ManageSubcontractors = 300005,
    ManageSecurityRoles = 300006,
    ManageCompanies = 300007,
    ManageUsersWithoutEmail = 300008,
    ManageSites = 300009,
    ViewRecurringJobsWithinCustomers = 300010,
    ViewServicesWithinSites = 300011,
    ViewRecurringJobsWithinSites = 300012,
    ViewAuditLog = 300013,
    CustomersView = 300014,
    CustomersCreate = 300015,
    CustomersEdit = 300016,
    CustomersDelete = 300017,
    ContractorsView = 300018,
    ContractorsCreate = 300019,
    ContractorsEdit = 300020,
    ContractorsDelete = 300021,
    SuppliersView = 300022,
    SuppliersCreate = 300023,
    SuppliersEdit = 300024,
    SuppliersDelete = 300025,
    EmployeesView = 300026,
    EmployeesCreate = 300027,
    EmployeesEdit = 300028,
    EmployeesDelete = 300029,
    TeamsView = 300030,
    TeamsCreate = 300031,
    TeamsEdit = 300032,
    TeamsDelete = 300033,
    CompaniesView = 300034,
    CompaniesEdit = 300035,
    ViewFinancialDetails = 300036,
}

export class CrmSecurityModule extends BaseSecurityModule<CrmSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Crm,
            [
                { _id: CrmSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: CrmSecurityRight.ManageServiceProviders, name: 'Manage Service Providers', basic: false },
                { _id: CrmSecurityRight.ManageCustomers, name: 'Manage Customers', basic: false },
                { _id: CrmSecurityRight.ManageSuppliers, name: 'Manage Suppliers', basic: false },
                { _id: CrmSecurityRight.ManageEmployees, name: 'Manage Employees', basic: false },
                { _id: CrmSecurityRight.ManageUsersWithoutEmail, name: 'Manage Users Without Email', basic: false },
                // Label only: the id and enum name keep the code's "Subcontractor" (WBS-12234 says "Contractors" on screen).
                { _id: CrmSecurityRight.ManageSubcontractors, name: 'Manage Contractors', basic: false },
                { _id: CrmSecurityRight.ManageSecurityRoles, name: 'Manage Security Roles', basic: false },
                { _id: CrmSecurityRight.ManageCompanies, name: 'Manage Companies', basic: false },
                { _id: CrmSecurityRight.ManageSites, name: 'Manage Sites', basic: false },
                { _id: CrmSecurityRight.ViewRecurringJobsWithinCustomers, name: 'View Recurring Jobs within Customers', basic: false },
                { _id: CrmSecurityRight.ViewServicesWithinSites, name: 'View Services within Sites', basic: false },
                { _id: CrmSecurityRight.ViewRecurringJobsWithinSites, name: 'View Recurring Jobs within Sites', basic: false },
                { _id: CrmSecurityRight.ViewAuditLog, name: 'View Audit Log', basic: false },
                { _id: CrmSecurityRight.ViewFinancialDetails, name: 'View Financial Details', basic: false },
                { _id: CrmSecurityRight.CustomersView, name: 'Customers › View', basic: false },
                { _id: CrmSecurityRight.CustomersCreate, name: 'Customers › Create', basic: false },
                { _id: CrmSecurityRight.CustomersEdit, name: 'Customers › Edit', basic: false },
                { _id: CrmSecurityRight.CustomersDelete, name: 'Customers › Delete', basic: false },
                { _id: CrmSecurityRight.ContractorsView, name: 'Contractors › View', basic: false },
                { _id: CrmSecurityRight.ContractorsCreate, name: 'Contractors › Create', basic: false },
                { _id: CrmSecurityRight.ContractorsEdit, name: 'Contractors › Edit', basic: false },
                { _id: CrmSecurityRight.ContractorsDelete, name: 'Contractors › Delete', basic: false },
                { _id: CrmSecurityRight.SuppliersView, name: 'Suppliers › View', basic: false },
                { _id: CrmSecurityRight.SuppliersCreate, name: 'Suppliers › Create', basic: false },
                { _id: CrmSecurityRight.SuppliersEdit, name: 'Suppliers › Edit', basic: false },
                { _id: CrmSecurityRight.SuppliersDelete, name: 'Suppliers › Delete', basic: false },
                { _id: CrmSecurityRight.EmployeesView, name: 'Employees › View', basic: false },
                { _id: CrmSecurityRight.EmployeesCreate, name: 'Employees › Create', basic: false },
                { _id: CrmSecurityRight.EmployeesEdit, name: 'Employees › Edit', basic: false },
                { _id: CrmSecurityRight.EmployeesDelete, name: 'Employees › Delete', basic: false },
                { _id: CrmSecurityRight.TeamsView, name: 'Teams › View', basic: false },
                { _id: CrmSecurityRight.TeamsCreate, name: 'Teams › Create', basic: false },
                { _id: CrmSecurityRight.TeamsEdit, name: 'Teams › Edit', basic: false },
                { _id: CrmSecurityRight.TeamsDelete, name: 'Teams › Delete', basic: false },
                { _id: CrmSecurityRight.CompaniesView, name: 'Companies › View', basic: false },
                { _id: CrmSecurityRight.CompaniesEdit, name: 'Companies › Edit', basic: false },
            ] as SecurityRight<CrmSecurityRight>[]
        );

        this.plan = TenantSubscription.System;
    }


}
